/**
 * @module compoenents/StationInfo
 * @author Charles Blais <charles.blais@canada.ca>
 */
import React from 'react';
import PropTypes from 'prop-types';
import queryString from 'query-string';

import { Table } from 'react-bootstrap';

import { getStatusColor, getStatusIndicator } from '../../libs/display';
import { useLanguageState } from '../../contexts/LanguageProvider';
import { useAppState } from '../../contexts/AppStateProvider';

import { Station } from '../../libs/networks';


const StationPopupContent = ({networkCode, station}) => {
  const [ lang ] = useLanguageState();
  const [ state ] = useAppState();
  
  let status = ''
  switch(getStatusIndicator(station)){
    case -1:
      status = lang.close;
      break;
    case 0:
      status = lang.open;
      break;
    case 1:
      status = lang.planned;
      break;
    default:
      status = '';
  }
  
  return (
    <>
      <Table bordered hover>
        <tbody>
          <tr>
            <th>{lang.network}</th>
            <td>{(networkCode in lang.networkCodes)?lang.networkCodes[networkCode]:networkCode}</td>
          </tr>
          <tr>
            <th>{lang.station}</th>
            <td>{station.code}</td>
          </tr>
          <tr>
            <th>{lang.status}</th>
            <td style={{backgroundColor:getStatusColor(station)}}>{status}</td>
          </tr>
          <tr>
            <th>{lang.name}</th>
            <td>{station.name}</td>
          </tr>
        </tbody>
      </Table>
      <a
        href={`?${queryString.stringify({
          network: networkCode,
          station: station.code,
          starttime: station.starttime.format(state.datetimeFormat),
          ...(station.endtime
              ? { endtime: station.endtime.format(state.datetimeFormat) }
              : {}),
        })}`}
      >{lang.moreDetails}</a>
    </>
  );
}


StationPopupContent.propTypes = {
  /**
   * Network code of the selected station
   */
  networkCode: PropTypes.string.isRequired,
  /**
   * Station object with required channels information
   */
  station: PropTypes.instanceOf(Station).isRequired,
};


StationPopupContent.propTypes = {
  setViewport: () => {},
};


export default StationPopupContent;